export default __webpack_public_path__ + "maps-examples-add-marker-symbol-thumbnail-480-4df819fe59a2a8cb606b157747f32dc9.png";